import * as React from 'react';
import { HTMLAttributes } from 'react';

export interface FieldsetProps extends HTMLAttributes<HTMLDivElement> {
  isRequired?: boolean;
  isOptional?: boolean;
  isInvalid?: boolean;
}

const FieldsetContext = React.createContext<FieldsetProps | undefined>(undefined);

export const FieldsetProvider = FieldsetContext.Provider;
export default FieldsetContext;
